import { createProxies } from "./proxies";

interface ConnectorExportsMethods {
  AddSelectedShape: (type: number) => void;
}

export interface ConnectorExports {
  Connector: ConnectorExportsMethods;
}

const {
  setup,
  addSelectedShape,
} = createProxies<ConnectorExportsMethods>([
  "AddSelectedShape",
]);

export {
  addSelectedShape,
  setup,
};
